import React from 'react';
import Script from 'next/script';
import { GoogleTagManager } from '@next/third-parties/google';

import { useConsent } from '@/components/CookieConsent';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
const HUBSPOT_PORTAL_ID = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;

interface MarketingScriptsProps {
  enableMarketing: boolean;
}

const MarketingScripts: React.FC<MarketingScriptsProps> = ({ enableMarketing }) => {
  const { canUseMarketing } = useConsent();

  // GTM loads unconditionally: Consent Mode v2 in advanced mode lets the tags
  // inside the container decide what they may store. Without consent GA4 still
  // sends cookieless pings, which keeps session counts and conversion
  // modelling alive without writing to the visitor's device.
  //
  // The `consent default` command is inline in _document's <head>, so it always
  // runs before this — do not load GTM earlier than afterInteractive.
  return (
    <>
      {GTM_ID && <GoogleTagManager gtmId={GTM_ID} />}
      {enableMarketing && canUseMarketing && HUBSPOT_PORTAL_ID && (
        <Script id="hs-script-loader" src={`https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`} strategy="lazyOnload" />
      )}
    </>
  );
};

export default MarketingScripts;
